import { postAPICall } from "../helpers/httpHelper";
import { db } from "../utils/db";

export const fetchAllIntegrationApplications = async () => {
  let apps;
  apps = await fetchAllIntegrationApplicationsFromLocal();
  if (!apps.length) {
    apps = await fetchAllIntegrationApplicationsFromDatabase();
  }
  return apps;
};
export const integrationApplications = async (applications) => {
    return await db.applications.bulkAdd(
        applications.map((d) => {
        d.createdAt = new Date().toISOString();
        return d;
      })
    );
  };
export const fetchAllIntegrationApplicationsFromLocal = () => {
  return db.applications.toArray();
};
export const fetchAllIntegrationApplicationsFromDatabase = async () => {
  const result = await postAPICall("GET", `/integrations/service/get-all-applications`);
  return result.data;
};